import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import Swal from "sweetalert2";
export default function StudentLeftside() {
  const [quizOpen, setQuizOpen] = useState(false);
  const [subjectOpen, setSubjectOpen] = useState(false);
  const [categoriesMenu, setCategoriesMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const [performanceOpen, setPerformanceOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // Normalize user object
  const normalizeUser = (u) => {
    if (!u) return null;

    const rawPicture =
      u.picture_url ??
      u.pictureUrl ??
      u.profile_pic ??
      u.profilePic ??
      u.avatar ??
      "";

    const picture_url =
      rawPicture && !/^https?:\/\//i.test(String(rawPicture))
        ? `${API_BASE_URL}/${String(rawPicture).replace(/^\/+/, "")}`
        : rawPicture || "";

    const city =
      u.city_title ??
      u.city ??
      u.city_name ??
      u.location ??
      u.state_title ??
      u.state_name ??
      null;

    return {
      id: u.id ?? u.userid ?? u.userId ?? "",
      name: u.name ?? u.fullname ?? u.username ?? "User",
      picture_url,
      location: city,
    };
  };


const handleTestSelection = async (cat) => {
  const result = await Swal.fire({
    title: "Select Test Type",
    text: "Choose which type of mock test you’d like to start.",
    

    showCancelButton: true,
    showCloseButton: true,

    confirmButtonText: "Chapter-wise Test",
    cancelButtonText: "Master Test",

    confirmButtonColor: "#00a65a",
    cancelButtonColor: "#1c5592",

    reverseButtons: false,
    allowOutsideClick: false,
    allowEscapeKey: true,
  });

  if (result.isConfirmed) {
    navigate(`/mocktest/chapterwise/${cat.id}`);
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    navigate(`/mocktest/masterquiz/${cat.id}`);
  }
};
  const user2 = JSON.parse(sessionStorage.getItem("user"));
  const userId = user2?.id;
  /* ---------------------------------------------------
   FETCH SUBJECT CATEGORIES (ONLY WHEN LOGGED IN)
--------------------------------------------------- */
  useEffect(() => {
    if (!userId) return;

    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/active_book_categories.php?user_id=${userId}`
        );

        if (!res.ok) throw new Error("API failed");

        const data = await res.json();

        if (data?.success && Array.isArray(data.categories)) {
          const formatted = data.categories.map((cat) => ({
            id: cat.category_id,
            title: cat.category_name || "Untitled Subject",
            image:
              cat.picture_url && cat.picture_url.trim() !== ""
                ? cat.picture_url
                : `${process.env.PUBLIC_URL}/assets/img/subject-placeholder.jpg`,
            isActive: Boolean(cat.isActive),
            daysLeft: Number(cat.daysLeft ?? 0),
          }));

          setCategoriesMenu(formatted);
        } else {
          setCategoriesMenu([]);
          setError("No subjects found");
        }
      } catch (err) {
        console.error("Subject fetch error:", err);
        setError("Failed to load subjects");
        setCategoriesMenu([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [userId]);


  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("user");
      if (raw) setUser(normalizeUser(JSON.parse(raw)));
    } catch { }

    const handleUserUpdated = (e) => {
      const newUser = e?.detail;
      if (newUser) {
        sessionStorage.setItem("user", JSON.stringify(newUser));
        setUser(normalizeUser(newUser));
      }
    };

    const handleStorage = (e) => {
      if (e.key === "user") {
        setUser(e.newValue ? normalizeUser(JSON.parse(e.newValue)) : null);
      }
    };

    window.addEventListener("userUpdated", handleUserUpdated);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("userUpdated", handleUserUpdated);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);


  useEffect(() => {
    const raw = sessionStorage.getItem("user");
    if (!raw) return;

    const parsedUser = JSON.parse(raw);
    const userId = parsedUser?.id;
    if (!userId) return;

    const interval = setInterval(() => {
      fetch(`${API_BASE_URL}/update_activity.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId }),
      }).catch(() => { });
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, []);


  const handleLogout = async () => {
    const raw = sessionStorage.getItem("user");

    if (raw) {
      const parsedUser = JSON.parse(raw);
      const userId = parsedUser?.id;

      try {
        await fetch(`${API_BASE_URL}/logout.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_id: userId }),
        });
      } catch { }
    }

    sessionStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };


  const profileImage =
    user?.picture_url?.trim()
      ? user.picture_url
      : `${process.env.PUBLIC_URL}/assets/img/profile.png`;
  const userName = user?.name || "User";
  const userLocation = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")).cityname || "" : "";

  const verify = sessionStorage.getItem("verifyNo");
  return (
    <div className="collapse" id="MobNav">
      <div className="dashboard-nav">

        {/* User Block */}
        <div className="dash-user-blocks pt-8">
          <div className="jbs-grid-usrs-thumb">
            <div className="jbs-grid-yuo">
               
             <figure>
  {user?.picture_url ? (

    <img
      src={profileImage}
      alt="User"
      className="img-fluid"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "cover",
        borderRadius: "50%",
        border: "3px solid #f58220",
      }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />

  ) : (

    <div
  style={{
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, #fff, #fff)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#1e4f8a",
    fontSize: "28px",
    fontWeight: "700",
    textTransform: "uppercase",
    boxShadow:
      "0 4px 12px rgba(0,0,0,0.15)",
    border: "3px solid #f58220",
    textDecoration: "none",
  }}
>
  {userName
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0, 2)}
</div>

  )}
</figure>
             
            </div>
          </div>

          <div className="jbs-grid-usrs-caption mb-3 text-center">
            <h4 className="mb-1">{userName}</h4>

            {userLocation && (
              <div className="text-muted">
                <i className="fa-solid fa-location-dot me-1"></i>
                {userLocation}
              </div>
            )}
          </div>
        </div>


        {/* Menu */}


        <div className="dashboard-inner" style={{ textAlign: "left" }}>
          <ul data-submenu-title="Main Navigation" >
            {verify === "Y" && (
              <>
                {/* Dashboard */}
                <li className={location.pathname === "/studentdashboard" ? "active" : ""}>
                  <Link to="/studentdashboard">
                    <i className="fa-solid fa-gauge-high me-2"></i>
                    Dashboard
                  </Link>
                </li>
                <li className={location.pathname === "/announcement" ? "active" : ""}>
                  <Link to="/announcement">
                    <i className="fa-solid fa-bullhorn me-2"></i>
                    Announcement
                  </Link>
                </li>
                {/* Quiz */}
                <li className={`dropdown-item ${quizOpen ? "active" : ""}`}>
                  <button
                    className="d-flex align-items-center w-100 bg-transparent border-0 text-start py-2"
                    onClick={() => setQuizOpen(!quizOpen)}
                  >
                    <i className="fa-solid fa-clipboard-question me-2"></i>
                    View Past Result
                    <i className={`fa-solid fa-chevron-down ms-auto ${quizOpen ? "rotate-180" : ""}`} />
                  </button>

                  {quizOpen && (
                    <ul className="list-unstyled mt-2 ps-3">
                      <li className={location.pathname === "/masterquizlist" ? "active" : ""}>
                        <Link to="/masterquizlist">
                          <i className="fa-regular fa-circle me-2" />
                          Master Quiz List
                        </Link>
                      </li>
                      <li className={location.pathname === "/chapterwisequizlist" ? "active" : ""}>
                        <Link to="/chapterwisequizlist">
                          <i className="fa-regular fa-circle me-2" />
                          Chapterwise Quiz List
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                {/* subject */}
             <li className={`dropdown-item ${subjectOpen ? "active" : ""}`}>
  <button
    className="d-flex align-items-center w-100 bg-transparent border-0 text-start py-2"
    onClick={() => setSubjectOpen(!subjectOpen)}
  >
    <i className="fa-solid fa-book me-2"></i>
    Subject
    <i
      className={`fa-solid fa-chevron-down ms-auto ${
        subjectOpen ? "rotate-180" : ""
      }`}
    />
  </button>

  {subjectOpen && (
    <ul className="list-unstyled mt-2 ps-3">
      {categoriesMenu.map((cat) => {
        const isActive = cat.isActive && cat.daysLeft > 0;

        const path = isActive
          ? `/start-test/${cat.id}`
          : `/subscription`;

        return (
          <li
  key={cat.id}
  className={location.pathname === path ? "active" : ""}
>
  <Link
    to={isActive ? "#" : `/subscription`}
    className="d-flex align-items-center"
    onClick={(e) => {
      if (isActive) {
        e.preventDefault(); // stop default navigation
        handleTestSelection(cat); // open modal
      }
    }}
  >
    {/* Left Icon */}
    <i className="fa-regular fa-circle me-2" />

    {/* Title */}
    <span>{cat.title}</span>

    {/* Lock Icon */}
    {!isActive && (
      <i className="fa-solid fa-lock ms-auto text-danger"></i>
    )}
  </Link>
</li>
        );
      })}
    </ul>
  )}
</li>

                {/* Performance & Results */}
                <li className={`dropdown-item ${performanceOpen ? "active" : ""}`}>
                  <button
                    className="d-flex align-items-center w-100 bg-transparent border-0 text-start py-2"
                    onClick={() => setPerformanceOpen(!performanceOpen)}
                  >
                    <i className="fa-solid fa-chart-line me-2"></i>
                    Performance & Results
                    <i
                      className={`fa-solid fa-chevron-down ms-auto ${performanceOpen ? "rotate-180" : ""
                        }`}
                    />
                  </button>

                  {performanceOpen && (
                    <ul className="list-unstyled mt-2 ps-3">

                      {/* OVERALL PERFORMANCE */}
                      <li className={location.pathname === "/analysis" ? "active" : ""}>
                        <Link to="/analysis">
                          <i className="fa-solid fa-gauge-high me-2"></i>
                          Overall Performance
                        </Link>
                      </li>


                    </ul>
                  )}
                </li>



                {/* Transaction */}

                <li className={location.pathname === "/subscriptionlist" ? "active" : ""}>
                  <Link to="/subscriptionlist">
                    <i className="fa-solid fa-money-check-alt me-2"></i>
                    Transaction
                  </Link>
                </li>



                {/* User Profile */}
                <li className={location.pathname === "/profile" ? "active" : ""}>
                  <Link to="/profile">
                    <i className="fa-regular fa-user me-2"></i>
                    User Profile
                  </Link>
                </li>
                {/* Change Password */}
                <li className={location.pathname === "/profile/password-change" ? "active" : ""}>
                  <Link to="/profile/password-change">
                    <i className="fa-solid fa-unlock-keyhole me-2"></i>
                    Change Password
                  </Link>
                </li>
              </>
            )}

            {verify === "N" && (
              <li className={location.pathname === "/complete-profile" ? "active" : ""}>
                <Link to="/complete-profile">
                  <i className="fa-solid fa-user-check me-2"></i>
                  Complete Profile
                </Link>
              </li>
            )}

            {/* Logout */}
            <li className="mt-3">
              <button onClick={handleLogout} className="btn btn-primary w-100">
                Logout
              </button>
            </li>

          </ul>
        </div>


      </div>
    </div>

  );
}
